module.exports = require('shared_frontend/components/popup').extend
  template: require('./index.pug')



// WEBPACK FOOTER //
// ./assets/js/frontend/components/popup_countries_map/index.coffee